import { render, staticRenderFns } from "./Inscriptions-dog-detail.vue?vue&type=template&id=72b342f1&scoped=true&"
import script from "./Inscriptions-dog-detail.vue?vue&type=script&lang=js&"
export * from "./Inscriptions-dog-detail.vue?vue&type=script&lang=js&"
import style0 from "./Inscriptions-dog-detail.vue?vue&type=style&index=0&id=72b342f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b342f1",
  null
  
)

export default component.exports